<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="measure"
      :rules="rules"
      ref="measureForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Intézkedés megnevezése"
        :error="errors.name ? errors.name[0] : null"
      >
        <el-input v-model="measure.name"/>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'measureId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        measure: {},
        errors: {
          name: null,
        },
        rules: {
          name :[
            { required: true, message: 'Inézkedés megadása kötelező', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új selejtezési intézkedés';
        } else if (this.type === 'update') {
          return 'Selejtezési intézkedés módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['measureForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.name = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('declutterMeasure/add', this.measure);
              } else if (this.type === 'update') {
                await this.$store.dispatch('declutterMeasure/update', this.measure);
              }
              this.$store.dispatch('declutterMeasure/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
                if(e.data && e.data.errors) {
                  this.errors = e.data.errors;
                }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.measureId) {
        this.measure = await this.$store.dispatch('declutterMeasure/fetch', this.measureId);
      }
      this.loading = false;
    }
  }
</script>
